// extracted by mini-css-extract-plugin
export default {"container":"eHt8M","title":"cP6DO","declarationContainer":"pjcK1","link":"XjXpC","checkbox":"sbTJt","actionsContainer":"m_bOw","cancelLink":"JcfAA","continueBtn":"ElJS0"};